import { render, staticRenderFns } from "./sidevip.vue?vue&type=template&id=5b104d88&scoped=true&"
import script from "./sidevip.vue?vue&type=script&lang=js&"
export * from "./sidevip.vue?vue&type=script&lang=js&"
import style0 from "./sidevip.vue?vue&type=style&index=0&id=5b104d88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b104d88",
  null
  
)

export default component.exports